import {
    Config,
    LegislativeChoropleth,
    TractChoropleth,
    TractVotingChoropleth,
    Layers
} from "../../data/Config/Config";


//TODO: RENAME something like CHOROPLETH STYLE MANAGER?
export default class MapMethods {
    constructor(_mapComponent) {
        this.mapComponent = _mapComponent;
        this.demoArrayManager = Config.demoArrayManager;
        this.tractDemoArrayManager = Config.tractDemoArrayManager;
        this.tractVotingDemoArrayManager = Config.tractVotingDemoArrayManager;
        this.tractsSet = false;
        this.tractsVAPSet = false;
    }
    setChoroplethStyle(_choroplethLayer) {
        let ChoroplethLayer = _choroplethLayer;

        if (typeof _choroplethLayer === 'string') {
            let _ChoroplethLayer = Config.layersConfig.layerArray.filter(l => l.id === _choroplethLayer);
            ChoroplethLayer = _ChoroplethLayer[0]
        }


        //console.log(Layers)
        switch (ChoroplethLayer.params.type) {
            case 'jurisdiction':
                this.setJursidictionStyle(ChoroplethLayer);
                break;
            case 'tract':
                if (!this.tractsSet) {
                    this.setTractCVAPStyle(ChoroplethLayer);
                }

                break;
            case 'tract-vap':
                if (!this.tractsVAPSet) {
                    this.setTractVAPStyle(ChoroplethLayer);
                }

                break;
        }
    }

    setJursidictionStyle(_choroplethLayer) {
        //console.trace()
        let now = performance.now();
        const self = this;
        var matchExpression = ["match", ["get", "geoid"]];
        const ColumnName = self.mapComponent.$store.getters.getMapColumn;
        _choroplethLayer.params.dataStyle = LegislativeChoropleth.config[ColumnName];
        var scale = _choroplethLayer.params.dataStyle.scale;

        let popThreshold = _choroplethLayer.params.dataStyle.popThreshold || 0;
        let thresholdColumn =
            _choroplethLayer.params.dataStyle.thresholdColumn || "";

        _choroplethLayer.params.data.forEach(function (row) {
            let val = row[self.demoArrayManager.ColToIdx(ColumnName)];

            let belowThreshold = false;
            if (popThreshold > 0) {
                belowThreshold =
                    row[self.demoArrayManager.ColToIdx(thresholdColumn)] /
                    row[self.demoArrayManager.ColToIdx("pop2020")] <
                    popThreshold;
            }

            let color = self.mapComponent.layerManager.GetColor(val, scale, belowThreshold);
            matchExpression.push(
                row[self.demoArrayManager.ColToIdx("geoid")],
                color
            );
        });

        // Last value is the default, used where there is no data
        matchExpression.push("rgba(0, 0, 0, 0)");

        self.mapComponent.map.setPaintProperty(
            _choroplethLayer.id,
            "fill-color",
            matchExpression, {
                validate: false
            }
        );

    }

    setTractCVAPStyle(_choroplethLayer) {
        console.log('set cvap style')
        const opacity = .7;
        const self = this;
        var matchExpression = ["match", ["get", "geoid"]];

        _choroplethLayer.params.data.forEach(function (row) {
            const plurality = row[1]
            if (!TractChoropleth.config[plurality] || typeof TractChoropleth.config[plurality] === 'undefined') {
                matchExpression.push(
                    row[self.tractDemoArrayManager.ColToIdx("geoid")],
                    "rgba(0, 0, 0, 0)"
                );
                return
            }
            _choroplethLayer.params.dataStyle = TractChoropleth.config[plurality];


            var scale = TractChoropleth.config[plurality].scale;

            const pluralityValColName = 'c_pct';
            const val = row[self.tractDemoArrayManager.ColToIdx(pluralityValColName)];
            let color = self.mapComponent.layerManager.GetColor(val, scale, false);

            matchExpression.push(
                row[self.tractDemoArrayManager.ColToIdx("geoid")],
                color
            );
        });


        matchExpression.push("rgba(0, 0, 0, 0)");

        this.mapComponent.map.setPaintProperty(
            'tract-cvap',
            "fill-color",
            matchExpression, {
                validate: false
            }
        );

        self.mapComponent.map.setPaintProperty(
            _choroplethLayer.id,
            "fill-outline-color",
            matchExpression, {
                validate: false
            }
        );

        this.tractsSet = true;
    }

    setTractVAPStyle(_choroplethLayer) {

        const opacity = .7;
        const self = this;
        var matchExpression = ["match", ["get", "geoid"]];
        console.log(_choroplethLayer.params.data[0])
        console.log(TractVotingChoropleth.config[_choroplethLayer.params.data[0][1]]);

        _choroplethLayer.params.data.forEach(function (row) {
            const plurality = row[1]
            if (!TractVotingChoropleth.config[plurality] || typeof TractVotingChoropleth.config[plurality] === 'undefined') {
                matchExpression.push(
                    row[self.tractVotingDemoArrayManager.ColToIdx("geoid")],
                    "rgba(0, 0, 0, 0)"
                );
                return
            }
            _choroplethLayer.params.dataStyle = TractVotingChoropleth.config[plurality];


            var scale = TractVotingChoropleth.config[plurality].scale;

            const pluralityValColName = 'v_pct';
            const plurIdx = self.tractVotingDemoArrayManager.ColToIdx(pluralityValColName) || 2;
            const val = row[2];
            let color = self.mapComponent.layerManager.GetColor(val, scale, false);

            matchExpression.push(
                row[self.tractVotingDemoArrayManager.ColToIdx("geoid")],
                color
            );
        });


        matchExpression.push("rgba(0,0,0,0)");

        this.mapComponent.map.setPaintProperty(
            'tract-vap',
            "fill-color",
            matchExpression, {
                validate: false
            }
        );

        self.mapComponent.map.setPaintProperty(
            _choroplethLayer.id,
            "fill-outline-color",
            matchExpression, {
                validate: false
            }
        );

        this.tractsVAPSet = true;
    }

}